/**
 * Entry point de la página / (Ventas).
 * La vista Datos Generales vive en su propia página: /general/
 */

import './styles/main.css';

import { state } from './state.js';
import { $ } from './utils/dom.js';
import { loadData } from './api/sheet.js';
import { bindHeaderRender, afterLoad } from './ui/header.js';
import { bindFilters, buildStatusChips, applyFilters } from './ui/filters.js';
import { renderKPIs } from './ui/kpis.js';
import { renderStatusTable } from './ui/statusTable.js';
import { renderAdTable } from './ui/adTable.js';
import { renderTrend, bindGrainButtons } from './ui/trend.js';
import { renderDetail } from './ui/detailTable.js';
import { bindSettingsButton } from './ui/settingsModal.js';
import { renderSheetSelect, bindSheetSelect, setSheetsList, setSheetsListError } from './ui/sheetSelector.js';
import { fetchSheetsList } from './api/sheetsList.js';
import { getActiveSheet } from './sheetsStore.js';
import { renderCurrencyToggle, bindCurrencyToggle, renderRateLabel, CURRENCY_CHANGED_EVENT } from './ui/currencyToggle.js';
import { fetchRates } from './api/exchangeRate.js';
import { renderMetaKPIs } from './ui/metaKpis.js';

function render() {
  renderKPIs();
  renderMetaKPIs();
  renderStatusTable();
  renderAdTable();
  renderTrend();
  renderDetail();
}

bindHeaderRender({ render, buildStatusChips, applyFilters });
bindFilters(render);
bindGrainButtons(renderTrend);
bindSettingsButton();

// ─── Moneda (toggle MXN/USD + tasa de cambio) ───────────────────────────
renderCurrencyToggle();
renderRateLabel();
bindCurrencyToggle(); // el toggle dispara el evento global; el listener re-renderiza
window.addEventListener(CURRENCY_CHANGED_EVENT, () => {
  renderSheetSelect(); // refleja la moneda asignada en las opciones del dropdown
  render();
});
window.addEventListener('clicchat:meta-updated', () => {
  loadData(true, afterLoad);
});
// Tasa en vivo: al llegar, repinta etiqueta y montos (el primer render usa fallback/cache).
fetchRates().then(() => { renderRateLabel(); render(); }).catch(() => {});

renderSheetSelect();
bindSheetSelect(() => {
  // Forzar re-render completo: la nueva hoja puede tener distintos status,
  // distinto rango de fechas y diferente número de filas.
  state.firstLoad = true;
  state.filters.statuses = new Set();
  loadData(false, afterLoad);
});

// ─── Descubrimiento automático de hojas ─────────────────────────────────
function discoverSheets() {
  return fetchSheetsList()
    .then(setSheetsList)
    .catch((err) => {
      console.warn('No se pudieron detectar las hojas del Sheet:', err);
      setSheetsListError();
    });
}
const initialDiscovery = discoverSheets();
setInterval(discoverSheets, 5 * 60 * 1000);

$('refreshBtn').onclick = () => loadData(false, afterLoad);

function startAutoRefresh() {
  if (state.autoRefreshTimer) return;
  state.autoRefreshTimer = setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    loadData(true, afterLoad);
  }, state.autoRefreshMs);
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    loadData(true, afterLoad);
  }
});

// ─── Carga inicial ──────────────────────────────────────────────────────
// Si hay cualquier hoja específica seleccionada (o modo "Todas"), esperamos
// al discovery para resolver el gid antes de la primera carga.
const needsDiscoveryFirst = getActiveSheet() !== '';
const initialLoad = needsDiscoveryFirst
  ? initialDiscovery.then(() => loadData(false, afterLoad))
  : loadData(false, afterLoad);
initialLoad.then(() => startAutoRefresh());
